export const ROUTES = {
  home: '/',
  newOccurrence: '/ocorrencias/nova',
  trackOccurrence: '/ocorrencias/acompanhar',
  adminLogin: '/administracao/entrar',
  adminHome: '/administracao',
  adminOccurrences: '/administracao/ocorrencias',
  adminAnalytics: '/administracao/indicadores',
  adminUsers: '/administracao/usuarios',
  adminTeams: '/administracao/equipes',
  adminAudit: '/administracao/auditoria',
  adminSettings: '/administracao/configuracoes',
  adminInfrastructure: '/administracao/infraestrutura',
  adminOccurrence: (id: string): string => `/administracao/ocorrencias/${encodeURIComponent(id)}`,
} as const;
